export default "__VITE_ASSET__B4K9v8fL__"